import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Router } from "@angular/router";
import { AppConstants } from "@core/constants/app";

@Component({
    selector: "app-step-wizard",
    templateUrl: "./step-wizard.component.html",
    styleUrls: ["./step-wizard.component.scss"],
    standalone: false,
})
export class StepWizardComponent {
    @Input() title: string;
    @Input() showTips: boolean;
    @Input() descr: string;
    @Input() postSubmitSectionContent: string | null = null;
    @Input() stepNumber: number;
    @Input() stepsTotal: number;
    @Input() showNextButton = true;
    @Input() lastStep = false;
    @Output() previousStepClicked = new EventEmitter();
    @Output() nextStepClicked = new EventEmitter();
    @Output() formCompleted = new EventEmitter();
    @Input() isSubmitting = false;

    constructor(private router: Router) {}

    get isFirstStep(): boolean {
        return this.stepNumber === 1;
    }

    get backLabel(): string {
        return this.isFirstStep ? "wizard.actions.backToDashboard" : "wizard.actions.back";
    }

    goToPreviousStep() {
        if (this.isFirstStep) {
            this.router.navigate([AppConstants.DASHBOARD_PAGE], {
                state: { skipLanguageModal: true },
            });
            return;
        }
        this.previousStepClicked.emit();
    }

    goToNextStep() {
        this.nextStepClicked.emit();
    }

    finishForm() {
        this.formCompleted.emit();
    }
}
